// Mapping from landing page name to file extension
export const LANDING_PAGE_TO_EXTENSION = {
  'word': 'docx',
  'excel': 'xlsx',
  'powerpoint': 'pptx',
  'keynote': 'key'
}
